import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

async function deleteShoppingList(folderId: number): Promise<void> {
  await axiosInstance.delete(api.deleteShoppingList(folderId));
}

interface UseDeleteShoppingListMutationOptions {
  onSuccess?: (folderId: number) => void;
  onError?: (error: unknown) => void;
}

const useDeleteShoppingListMutation = ({
  onSuccess,
  onError,
}: UseDeleteShoppingListMutationOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteShoppingList,
    onSuccess: (_data, folderId) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.favorite.allFolders() });
      queryClient.invalidateQueries({ queryKey: queryKeys.favorite.folders() });
      onSuccess?.(folderId);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export default useDeleteShoppingListMutation;
